/* ==========================================
   FIALLO Wishlist — localStorage based
   ========================================== */
(function () {
    var STORAGE_KEY = 'fiallo_wishlist';

    function getWishlist() {
        try {
            var raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch (e) { return []; }
    }

    function saveWishlist(items) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        } catch (e) {}
    }

    function isSaved(id) {
        var w = getWishlist();
        return w.some(function (p) { return String(p.id) === String(id); });
    }

    function toggle(product) {
        var w = getWishlist();
        var i = w.findIndex(function (p) { return String(p.id) === String(product.id); });
        if (i > -1) {
            w.splice(i, 1);
            saveWishlist(w);
            return false; // removed
        }
        w.push(product);
        saveWishlist(w);
        return true; // added
    }

    function updateBadge() {
        var count = getWishlist().length;
        document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
            el.textContent = count;
            if (count > 0) {
                el.classList.add('is-visible');
            } else {
                el.classList.remove('is-visible');
            }
        });
    }

    function bindBookmarkButtons() {
        document.querySelectorAll('.collection-bookmark').forEach(function (btn) {
            if (btn.dataset.wishlistBound) return;
            btn.dataset.wishlistBound = '1';
            if (isSaved(btn.dataset.productId)) {
                btn.classList.add('is-saved');
            }
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var product = {
                    id: btn.dataset.productId,
                    handle: btn.dataset.productHandle,
                    title: btn.dataset.productTitle,
                    url: btn.dataset.productUrl,
                    image: btn.dataset.productImage,
                    price: btn.dataset.productPrice
                };
                var added = toggle(product);
                btn.classList.toggle('is-saved', added);
                updateBadge();
                // Re-render wishlist page if open
                if (typeof window.renderWishlistPage === 'function') {
                    window.renderWishlistPage();
                }
            });
        });
    }

    function escapeHtml(s) {
        if (s == null) return '';
        return String(s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }

    // Render the dedicated wishlist page grid (AMIRI-style)
    function renderWishlistPage() {
        var grid = document.getElementById('wishlistGrid');
        var empty = document.getElementById('wishlistEmpty');
        var share = document.getElementById('wishlistShareWrap');
        if (!grid) return;
        var list = getWishlist();
        if (!list.length) {
            grid.innerHTML = '';
            if (empty) empty.style.display = 'block';
            if (share) share.style.display = 'none';
            return;
        }
        if (empty) empty.style.display = 'none';
        if (share) share.style.display = 'flex';

        grid.innerHTML = list.map(function (p) {
            return ''
                + '<a href="' + escapeHtml(p.url) + '" class="collection-card wishlist-card" data-id="' + escapeHtml(p.id) + '">'
                +   '<button type="button" class="wishlist-card-remove" data-id="' + escapeHtml(p.id) + '" aria-label="Remove">'
                +     '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#181818" stroke-width="1.2"><path d="M5 5l14 14M19 5L5 19" stroke-linecap="round"/></svg>'
                +   '</button>'
                +   '<div class="collection-card-image">'
                +     (p.image ? '<img class="collection-card-img collection-card-img-primary" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '')
                +   '</div>'
                +   '<div class="collection-card-info">'
                +     '<div class="collection-card-text">'
                +       '<h3 class="collection-card-name">' + escapeHtml(p.title) + '</h3>'
                +       '<p class="collection-card-price">' + escapeHtml(p.price) + '</p>'
                +     '</div>'
                +   '</div>'
                + '</a>';
        }).join('');

        grid.querySelectorAll('.wishlist-card-remove').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var id = btn.dataset.id;
                var w = getWishlist().filter(function (p) { return String(p.id) !== String(id); });
                saveWishlist(w);
                updateBadge();
                renderWishlistPage();
                document.querySelectorAll('.collection-bookmark').forEach(function (b) {
                    if (String(b.dataset.productId) === String(id)) b.classList.remove('is-saved');
                });
            });
        });

        // Prevent the card's outer <a> from triggering when clicking the X
        grid.querySelectorAll('.wishlist-card').forEach(function (a) {
            a.addEventListener('click', function (e) {
                if (e.target.closest('.wishlist-card-remove')) {
                    e.preventDefault();
                }
            });
        });
    }

    window.renderWishlistPage = renderWishlistPage;

    // Expose helpers
    window.FialloWishlist = {
        get: getWishlist,
        save: saveWishlist,
        toggle: toggle,
        isSaved: isSaved,
        updateBadge: updateBadge,
        bindBookmarkButtons: bindBookmarkButtons,
        renderWishlistPage: renderWishlistPage
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            bindBookmarkButtons();
            updateBadge();
            renderWishlistPage();
        });
    } else {
        bindBookmarkButtons();
        updateBadge();
        renderWishlistPage();
    }
})();
